import React, { useContext } from "react"
import defaultFM from "../data/manual/floating-mem.json"

const FloatingMemCtx = React.createContext(null)

export const FloatingMemProvider = ({ children }) => {
  const [map, setMap] = React.useState(defaultFM)
  return (
    <FloatingMemCtx.Provider
      value={{
        map,
        setMap,
      }}
    >
      {children}
    </FloatingMemCtx.Provider>
  )
}

export const useFloatingMemCtx = () => {
  const data = useContext(FloatingMemCtx)
  if (!data) throw new Error("called context hook outside provider")
  return data
}
